var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7564 17.3902C15.6985 16.9643 15.1995 16.7626 14.8619 17.0288L11.6288 19.5779C11.2939 19.8421 11.3692 20.3695 11.7647 20.5293L15.5526 22.0597C15.9481 22.2195 16.3687 21.8924 16.3112 21.4697L15.7564 17.3902Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5574 6.69133C18.0212 6.07066 16.2727 6.81285 15.6521 8.34906L13.7977 7.59985C14.8321 5.0395 17.7463 3.80252 20.3066 4.83696C22.867 5.87141 24.104 8.78557 23.0695 11.3459L21.9459 14.1269L23.3375 14.6892C24.1056 14.9995 24.4767 15.8738 24.1664 16.6419L19.1092 29.1588L5.66505 23.7271C4.89694 23.4167 4.52585 22.5425 4.83618 21.7744L9.33146 10.6482C9.6418 9.88006 10.516 9.50896 11.2841 9.8193L20.0916 13.3777L21.2152 10.5967C21.8358 9.06049 21.0936 7.312 19.5574 6.69133ZM10.9985 11.861L6.87786 22.06L18.0041 26.5553L22.1247 16.3562L10.9985 11.861Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;